import React, { Component } from 'react';
import WowBis from 'components/wow/WowBis'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as wowActions from 'store/modules/wow';

class WowBisContainer extends Component {

  componentDidMount() {
    this.getItemList();
  }

  getItemList = async () => {
    const {WowActions, wowBis} = this.props;
    const {itemList} = wowBis;
    
    try {
      if(!itemList.length > 0) {
        await WowActions.getItemList();
      }
    }catch(e){
      console.log(e);
    }
  }

  fnBisFilter = (e) => {
    const {WowActions} = this.props;
    const {id} = e.target;

    WowActions.setBisFilterOpt({id});
  }

  fnFilterReset = () => {
    const {WowActions} = this.props;

    WowActions.setBisFilterReset();
  }

  render() {
    const {wowBis, lang} = this.props;
    const {fnBisFilter, fnFilterReset} = this;

    return (
      <WowBis wowBis={wowBis} fnBisFilter={fnBisFilter} lang={lang}
      fnFilterReset={fnFilterReset}
      />
    );
  }
}

export default connect(
  (state) => ({
    wowBis: state.wow.toJS().wowBis,
    lang: state.wow.toJS().lang
  }),
  (dispatch) => ({
    WowActions: bindActionCreators(wowActions, dispatch)
  })
)(WowBisContainer);